import store, { getStoreMode } from "./store.adapter";

// always export this (used in UI sometimes)
export { getStoreMode };

// always export the built-in packs from local store
export { DEFAULT_PACKS } from "./store.local";

// helper: make sync OR async values behave like Promises
const asPromise = (v) => (v && typeof v.then === "function" ? v : Promise.resolve(v));

// ============================================================================
// TENANTS
// ============================================================================
export const getTenants = (...args) => asPromise(store.getTenants(...args));
export const getTenant = (...args) => asPromise(store.getTenant(...args));
export const saveTenant = (...args) => asPromise(store.saveTenant(...args));
export const deleteTenant = (...args) => asPromise(store.deleteTenant(...args));
export const updateTenantLifecycle = (...args) =>
  store.updateTenantLifecycle ? asPromise(store.updateTenantLifecycle(...args)) : Promise.resolve({ success: false });

// ============================================================================
// SPECIALTIES (Firebase only - returns empty for local)
// ============================================================================
export const getSpecialties = (...args) => 
  store.getSpecialties ? asPromise(store.getSpecialties(...args)) : Promise.resolve({});
export const getSpecialty = (...args) => 
  store.getSpecialty ? asPromise(store.getSpecialty(...args)) : Promise.resolve(null);
export const saveSpecialty = (...args) => 
  store.saveSpecialty ? asPromise(store.saveSpecialty(...args)) : Promise.resolve({ success: false });
export const deleteSpecialty = (...args) => 
  store.deleteSpecialty ? asPromise(store.deleteSpecialty(...args)) : Promise.resolve(false);

// ============================================================================
// PACKS
// ============================================================================
export const getPacks = (...args) => asPromise(store.getPacks(...args));
export const getPackByDocId = (...args) => 
  store.getPackByDocId ? asPromise(store.getPackByDocId(...args)) : Promise.resolve(null);
export const savePackVersion = (...args) => asPromise(store.savePackVersion(...args));
export const deletePack = (...args) => asPromise(store.deletePack(...args));
export const getPackVersions = (...args) => asPromise(store.getPackVersions(...args));
export const isCustomPack = (...args) => asPromise(store.isCustomPack(...args));

// New pack functions (Firebase only)
export const updatePackStatus = (...args) =>
  store.updatePackStatus ? asPromise(store.updatePackStatus(...args)) : Promise.resolve({ success: false });
export const setActivePack = (...args) =>
  store.setActivePack ? asPromise(store.setActivePack(...args)) : Promise.resolve({ success: false });
export const updatePackDoc = (...args) =>
  store.updatePackDoc ? asPromise(store.updatePackDoc(...args)) : Promise.resolve({ success: false });

// ============================================================================
// METRICS
// ============================================================================
export const saveMetricEvent = (...args) => asPromise(store.saveMetricEvent(...args));
export const getMetrics = (...args) => asPromise(store.getMetrics(...args));
export const getMetricsBySpecialty = (...args) => 
  store.getMetricsBySpecialty ? asPromise(store.getMetricsBySpecialty(...args)) : Promise.resolve([]);
export const getMetricsByUser = (...args) => 
  store.getMetricsByUser ? asPromise(store.getMetricsByUser(...args)) : Promise.resolve([]);

// ============================================================================
// AUDIT LOGS
// ============================================================================
export const saveAuditLog = (...args) => asPromise(store.saveAuditLog(...args));
export const getAuditLogs = (...args) => asPromise(store.getAuditLogs(...args));
export const getAuditLogsBySpecialty = (...args) => 
  store.getAuditLogsBySpecialty ? asPromise(store.getAuditLogsBySpecialty(...args)) : Promise.resolve([]);
export const getAuditLogsByUser = (...args) => 
  store.getAuditLogsByUser ? asPromise(store.getAuditLogsByUser(...args)) : Promise.resolve([]);
export const getAuditLog = (...args) => 
  store.getAuditLog ? asPromise(store.getAuditLog(...args)) : Promise.resolve(null);

// ============================================================================
// TENANT SETTINGS
// ============================================================================
export const getTenantSettings = (...args) => asPromise(store.getTenantSettings(...args));
export const getSecuritySettings = (...args) => asPromise(store.getSecuritySettings(...args));
export const saveTenantSettings = (...args) => asPromise(store.saveTenantSettings(...args));
export const saveSecuritySettings = (...args) => asPromise(store.saveSecuritySettings(...args));

// ============================================================================
// USERS
// ============================================================================
export const getUsers = (...args) => asPromise(store.getUsers(...args));
export const getTenantUsers = (...args) => asPromise(store.getTenantUsers(...args));
export const getUser = (...args) =>
  store.getUser ? asPromise(store.getUser(...args)) : Promise.resolve(null);
export const getTenantUser = (...args) =>
  store.getTenantUser ? asPromise(store.getTenantUser(...args)) : Promise.resolve(null);
export const saveUser = (...args) => asPromise(store.saveUser(...args));
export const updateUserStatus = (...args) => 
  store.updateUserStatus ? asPromise(store.updateUserStatus(...args)) : Promise.resolve({ success: false });
export const deleteUser = (...args) => asPromise(store.deleteUser(...args));

// ============================================================================
// SEED (Firebase only)
// ============================================================================
export const getSeedSpecialties = (...args) => 
  store.getSeedSpecialties ? asPromise(store.getSeedSpecialties(...args)) : Promise.resolve({});
export const getSeedPacks = (...args) => 
  store.getSeedPacks ? asPromise(store.getSeedPacks(...args)) : Promise.resolve({});
export const saveSeedSpecialty = (...args) => 
  store.saveSeedSpecialty ? asPromise(store.saveSeedSpecialty(...args)) : Promise.resolve({ success: false });
export const saveSeedPack = (...args) => 
  store.saveSeedPack ? asPromise(store.saveSeedPack(...args)) : Promise.resolve({ success: false });
export const seedTenant = (...args) => 
  store.seedTenant ? asPromise(store.seedTenant(...args)) : Promise.resolve({ success: false });

// ============================================================================
// PLATFORM STATS (Firebase only)
// ============================================================================
export const getPlatformStats = (...args) => 
  store.getPlatformStats ? asPromise(store.getPlatformStats(...args)) : Promise.resolve({ tenants: { total: 0, active: 0 }, users: { total: 0, active: 0 } });
